import { combineReducers } from 'redux';
import { appReducer } from './appReducer';

export const RootReducers = combineReducers({
  app: appReducer,
});
